// extracted by mini-css-extract-plugin
module.exports = {"withFooter":"style_withFooter__dJaB9"};